// extracted by mini-css-extract-plugin
module.exports = {"loadingBanner":"_16a7b27a"};